module.exports = __webpack_public_path__ + "img/wecats.208a93bf.jpg";